import React from 'react';
import PageHeader from '../../Common/PageHeader';
import Icons from '../../../../components/Common/Icons/Icons';

function UnreviewedDoc() {
  return (
    <div>
      <PageHeader icon={<Icons.AccountsFilled />} title="December Statement" />

      <div className="mx-[20px] z-[1000] grid gap-[20px] relative overflow-hidden rounded-[10px]">
        <iframe
          title="Single-Doc-Page"
          src="/UnreviewedDocumentPage/December-Statement_eStatements.html"
          width="100%"
          // height="600px"
          className="block h-[87vh]"
        />
      </div>
    </div>
  );
}

export default UnreviewedDoc;
